import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from '@/app/App';
import { queryClient } from '@/api/queryClient';
import { startLiveStream } from '@/api/liveStream';
import '@/styles/index.css';
// Register the sequence-clock flow's eventBus subscription at app start.
import '@/domain/sequenceFlow';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found. index.html must include <div id="root"></div>');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

startLiveStream();
